import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "28",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M2.813 0C1.26 0 0 1.232 0 2.75c0 .865.416 1.679 1.125 2.2l12.75 9.35a1.915 1.915 0 0 0 2.25 0l12.75-9.35A2.73 2.73 0 0 0 30 2.75C30 1.232 28.74 0 27.188 0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M0 2.75v15.583C0 20.356 1.682 22 3.75 22h22.5c2.068 0 3.75-1.644 3.75-3.667V2.75c0 .865-.416 1.679-1.125 2.2l-12.75 9.35a1.915 1.915 0 0 1-2.25 0L1.125 4.95A2.73 2.73 0 0 1 0 2.75",
  opacity: ".3"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }